import { handleActions } from 'redux-actions';
import {
  loadAllTags,
  paginateTags,
  filterTags,
  changeSortConfigTag,
  loadAllTagsTranslate,
} from '../actions/tagActions';

const defaultState = {
  tags: [],
  tagsTranslate: [],
  currentTags: [],
  sortConfig: [],
};

export default handleActions(
  {
    [loadAllTags](state, action) {
      return { ...state, tags: action.payload };
    },
    [loadAllTagsTranslate](state, action) {
      return { ...state, tagsTranslate: action.payload };
    },
    [paginateTags](state, action) {
      const { page, pageSize } = action.payload;
      const start = (page - 1) * pageSize;
      const end = page * pageSize;
      const currentTags = [...state.tags].slice(start, end);
      return { ...state, currentTags };
    },
    [filterTags](state, action) {
      const { value } = action.payload;
      const tags = state.tags.filter(
        (tag) =>
          value === '' ||
          tag.name.toLowerCase().includes(value) ||
          tag.name.toUpperCase().includes(value)
      );
      return { ...state, tags };
    },
    [changeSortConfigTag](state, action) {
      const sortOption = state.sortConfig.find(
        (currentSortOption) => currentSortOption.field === action.payload
      );
      if (sortOption) {
        return sortOption.asc
          ? {
              ...state,
              sortConfig: state.sortConfig.map((currentSortOption) =>
                currentSortOption.field === sortOption.field
                  ? { ...currentSortOption, asc: false }
                  : currentSortOption
              ),
            }
          : {
              ...state,
              sortConfig: state.sortConfig.filter(
                (currentSortOption) => currentSortOption.field !== sortOption.field
              ),
            };
      }
      return {
        ...state,
        sortConfig: [...state.sortConfig, { model: 'Tag', field: action.payload, asc: true }],
      };
    },
  },
  defaultState
);
